import {
  Users,
  Shield,
  Heart,
  Activity,
  Trophy,
  CheckCircle2,
  Calendar,
  Sun,
  MapPin,
} from 'lucide-react'
// Real reviews most relevant to the Summer Camp page (parents speaking to
// their kids having fun in a positive, supervised environment). Pulled from
// STORM_REVIEWS by name to avoid drifting if the array order changes.
export const CAMP_REVIEW_NAMES = [
  'Pavani Kanduri',
  'Sweety Darla',
  'Mike Seibert',
]
// === EDITABLE CAMP CONFIG (2026 Season) ===
export const CAMP_SEASON = {
  year: '2026',
  theme: 'Unleash Your Inner Storm Warrior',
  hours: 'Mon–Fri, 10:00 AM – 4:00 PM',
  ages: 'Ages 6 and up',
  registrationPhone: '517-225-9501',
  registrationEmail: 'megan@stormtaekwondo.com',
  mainPhone: '517-220-0621',
}
export const WEEKLY_SESSIONS = [
  {
    week: 1,
    dates: 'June 22 – June 26, 2026',
    short: 'Jun 22 – 26',
    days: 'Mon–Fri',
    depositUrl: 'LINK_TO_WEEK_1_DEPOSIT_PRODUCT',
  },
  {
    week: 2,
    dates: 'July 13 – July 17, 2026',
    short: 'Jul 13 – 17',
    days: 'Mon–Fri',
    depositUrl: 'LINK_TO_WEEK_2_DEPOSIT_PRODUCT',
  },
  {
    week: 3,
    dates: 'August 3 – August 7, 2026',
    short: 'Aug 3 – 7',
    days: 'Mon–Fri',
    depositUrl: 'LINK_TO_WEEK_3_DEPOSIT_PRODUCT',
  },
  {
    week: 4,
    dates: 'August 17 – August 21, 2026',
    short: 'Aug 17 – 21',
    days: 'Mon–Fri',
    depositUrl: 'LINK_TO_WEEK_4_DEPOSIT_PRODUCT',
  },
]
export const PRICING = [
  {
    title: 'One-Week Session',
    price: '$200',
    sub: 'per week',
    copy: 'Standard rate for new / non-enrolled students.',
  },
  {
    title: 'Additional Child',
    price: '$100',
    sub: 'per week',
    copy: 'For each additional child in the same family.',
  },
  {
    title: 'Enrolled Student',
    price: '$150',
    sub: 'per week',
    copy: 'Discounted rate for currently enrolled Storm students.',
  },
  {
    title: 'Enrolled Additional Child',
    price: '$75',
    sub: 'per week',
    copy: 'For each additional child of an enrolled student.',
  },
]
export const TRUST_BADGES = [
  'Ages 6+',
  'Weekly Sessions',
  'Mon–Fri Camp',
  'Shirts Included',
  'Pay Weekly or Daily',
  'No Capacity Limit',
  'Farmington Hills',
]
export const BENEFITS = [
  {
    icon: Users,
    title: 'Social Skills Development',
    copy: 'Kids build interaction, sharing and teamwork skills in a structured group environment.',
  },
  {
    icon: Heart,
    title: 'Confidence & Independence',
    copy: 'Camp helps kids gain independence, confidence and comfort working with peers.',
  },
  {
    icon: Shield,
    title: 'Safe & Supervised Environment',
    copy: 'Children are cared for in a secure, organized setting led by the Storm Taekwondo team.',
  },
  {
    icon: Trophy,
    title: 'Fun Taekwondo-Themed Games',
    copy: 'Active games and movement help kids build focus, coordination and confidence in a fun environment.',
  },
  {
    icon: Activity,
    title: 'Fitness & Movement',
    copy: 'Kids move, stretch, train and stay active during the summer instead of sitting all day.',
  },
  {
    icon: CheckCircle2,
    title: 'Dependable Daily Structure',
    copy: 'Parents get a reliable camp option while kids stay active, supervised and engaged.',
  },
]
export const ACTIVITIES = [
  'Active group games',
  'Fitness games',
  'Team-building activities',
  'Confidence challenges',
  'Taekwondo-themed games',
  'Stretching and movement',
  'Indoor camp activities',
  'Lunch and snack breaks',
]
export const WHAT_TO_BRING = [
  'Packed lunch',
  'Snack',
  'Water bottle',
  'Comfortable clothes',
  'Positive attitude',
]
export const WHY_STORM = [
  {
    icon: Calendar,
    title: 'Structured Environment',
    copy: 'Predictable, organized daily schedule kids can rely on.',
  },
  {
    icon: Sun,
    title: 'Active Summer Schedule',
    copy: 'Kids stay moving instead of sitting in front of screens.',
  },
  {
    icon: Trophy,
    title: 'Hosted by Storm Taekwondo',
    copy: 'An active kids camp hosted inside the Storm Taekwondo facility by familiar coaches.',
  },
  {
    icon: Shield,
    title: 'Supervised Group Setting',
    copy: 'Trained Storm staff oversee every camp session.',
  },
  {
    icon: Users,
    title: 'Teamwork & Social Skills',
    copy: 'Group activities help kids make friends and collaborate.',
  },
  {
    icon: MapPin,
    title: 'Located in Farmington Hills',
    copy: 'Conveniently located on Crestview for local families.',
  },
]
